import type {CommentsPreference} from '@github-ui/diff-view-settings/types'
import type {StateCreator} from 'zustand'

export interface SettingsSlice {
  isSingleFileMode: boolean
  commentsPreference: CommentsPreference
  settingsActions: {
    updateCommentsPreference: (preference: CommentsPreference) => void
  }
}
export interface SettingsSliceOpts {
  isSingleFileMode: boolean
  commentsPreference: CommentsPreference
}

export const createSettingsSlice =
  ({
    isSingleFileMode,
    commentsPreference,
  }: SettingsSliceOpts): StateCreator<SettingsSlice, [['zustand/devtools', never]], [], SettingsSlice> =>
  set => ({
    isSingleFileMode,
    commentsPreference,
    settingsActions: {
      updateCommentsPreference: preference => {
        set(() => ({
          commentsPreference: preference,
        }))
      },
    },
  })
